var path = '/home/travis/build/orizens/echoes/src/components/search-panel/search-panel.tpl.html';
var html = "<div class=search-panel><form class=\"navbar-form form-search navbar-left\" id=media-explorer ng-submit=$ctrl.search()><div class=\"form-group clearfix\"><input placeholder=\"Explore Media\" id=media-search type=search class=form-control autocomplete=off ng-model=$ctrl.params.q ng-model-options=\"{ debounce: 300 }\" ng-change=$ctrl.resetPageToken() uib-typeahead=\"q for q in $ctrl.complete($viewValue)\" typeahead-on-select=\"$ctrl.updateSearch($item, $model, $label)\" typeahead-show-hint=true> <button class=\"btn btn-transparent btn-submit\" type=submit title=\"search with echoes\"><i class=\"fa fa-search\"></i></button></div></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/search-panel/search-panel.tpl.html
 ** module id = 131
 ** module chunks = 1
 **/